// extracted by mini-css-extract-plugin
module.exports = {"checkList":"CheckList-module--checkList--1Kyg_","checkList__item":"CheckList-module--checkList__item--LhOga","blue":"CheckList-module--blue--3mbns"};